import React, { FC, useEffect }     from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, TextArea }           from "semantic-ui-react";
import GetMailSetting               from "../../../../../application/usecase/mail/setting/GetMailSetting";
import MailFooter                   from "../../../../../domain/mail/setting/MailFooter";
import MailReplyTo                     from "../../../../../domain/mail/setting/MailReplyTo";
import MailSetting                  from "../../../../../domain/mail/setting/MailSetting";
import MailSettingRepository        from "../../../../../domain/mail/setting/MailSettingRepository";
import { ResKaState }               from "../../../../../index";
import MailSettingDataSource        from "../../../../../infrastructure/datasource/mail/setting/MailSettingDataSource";
import ValidatorMessage             from "../../../message/ValidatorMessage";

const MailSettingFrom: FC = () => {
  const mailSetting: MailSetting = useSelector((state: ResKaState) => state.mailSetting);
  const repository: MailSettingRepository = new MailSettingDataSource(useDispatch());
  const getMailSetting: GetMailSetting = new GetMailSetting(useDispatch());

  useEffect(() => {
    getMailSetting.execute();
  }, []);

  return (
    <>
      <Form>
        <Form.Field required>
          <label>返信先メールアドレス</label>
          <Form.Input
            defaultValue={ mailSetting.replyTo.value }
            placeholder="メールの受信者が返信可能なメールアドレスを入力してください。"
            onChange={ (event, data) => repository.setMailSettingReplyTo(new MailReplyTo(data.value)) }
          />
          <ValidatorMessage target="from"/>
        </Form.Field>
        <Form.Field>
          <label>メールフッター</label>
          <TextArea
            defaultValue={ mailSetting.footer.value }
            rows={ 20 }
            placeholder="メールの末尾に載せたい内容を入力してください。"
            onChange={ (event, data) => repository.setMailSettingFooter(new MailFooter(data.value as string)) }
          />
        </Form.Field>
      </Form>
    </>
  );
};

export default MailSettingFrom;
